(function () {
  function initHome(root) {
    if (!root || root.dataset.bunkyHomeInit === 'true') return;
    root.dataset.bunkyHomeInit = 'true';

    root.querySelectorAll('[data-bunky-acc-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('[data-bunky-acc-row]');
        if (!row) return;
        var open = row.classList.contains('active');
        root.querySelectorAll('[data-bunky-acc-row]').forEach(function (r) {
          r.classList.remove('active');
          var c = r.querySelector('[data-bunky-acc-content]');
          if (c) c.style.display = 'none';
        });
        if (!open) {
          row.classList.add('active');
          var content = row.querySelector('[data-bunky-acc-content]');
          if (content) content.style.display = 'block';
        }
      });
    });

    var modal = root.querySelector('[data-bunky-video-modal]');
    var player = root.querySelector('[data-bunky-video-player]');
    var playBtn = root.querySelector('[data-bunky-video-trigger]');
    var closeBtn = root.querySelector('[data-bunky-video-close]');

    function openVideo() {
      if (!modal) return;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      if (player) {
        player.currentTime = 0;
        player.play().catch(function () {});
      }
    }

    function closeVideo() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (player) player.pause();
    }

    if (playBtn) playBtn.addEventListener('click', openVideo);
    if (closeBtn) closeBtn.addEventListener('click', closeVideo);
    if (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeVideo();
      });
    }
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) closeVideo();
    });

    function syncStoreMarqueeDistance(marquee) {
      var group = marquee.querySelector('.store-marquee__group');
      if (!group) return;
      marquee.style.setProperty('--store-marquee-distance', group.scrollWidth + 'px');
    }

    root.querySelectorAll('[data-bunky-store-marquee]').forEach(function (marquee) {
      syncStoreMarqueeDistance(marquee);
      window.addEventListener('resize', function () {
        syncStoreMarqueeDistance(marquee);
      });
      marquee.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) {
          img.addEventListener('load', function () {
            syncStoreMarqueeDistance(marquee);
          }, { once: true });
        }
      });
    });

    var heroVideo = root.querySelector('[data-bunky-hero-video]');
    var heroPoster = root.querySelector('[data-bunky-hero-video-poster]');

    function hideHeroPoster() {
      if (heroPoster) {
        heroPoster.classList.add('is-hidden');
      }
      if (heroVideo) {
        heroVideo.removeAttribute('poster');
      }
    }

    if (heroVideo) {
      if (!heroVideo.paused && heroVideo.readyState >= 2) {
        hideHeroPoster();
      }
      heroVideo.addEventListener('playing', hideHeroPoster, { once: true });
      heroVideo.addEventListener('error', function () {
        if (heroPoster) heroPoster.classList.remove('is-hidden');
      });
    } else if (heroPoster) {
      heroPoster.classList.remove('is-hidden');
    }

    var scrollTop = root.querySelector('[data-bunky-scroll-top]');
    function onScroll() {
      if (scrollTop) scrollTop.classList.toggle('show', window.scrollY > 580);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    scrollTop?.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function boot() {
    document.querySelectorAll('[data-bunky-home]').forEach(initHome);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
